<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="800px"
      scrollable
      @keydown="executeCloseModalComments"
      @click:outside="executeCloseModalComments"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5
            v-if="currentItem"
            v-html="
              `Comentarios de solicitud <b>${getTitleFromCurrentItem()}</b> `
            "
          ></h5>
        </div>
        <hr />
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <v-row
              class="mx-0 mb-8 scroll-vertical"
              style="max-height: 400px"
              v-if="currentItem && currentItem.comments.length"
            >
              <v-col
                cols="12"
                md="12"
                sm="12"
                class="py-0 my-0"
                style="border-radius: 24px"
                v-for="(item, index) in currentItem.comments"
                :key="index"
              >
                <v-row justify="start" align-content="center">
                  <v-col cols="12" md="12" sm="12" class="mb-8">
                    <div class="mr-2" style="border-radius: 15px">
                      <div
                        class="mb-2 ml-1 d-flex align-items-center justify-content-start"
                      >
                        <v-btn
                          class="mr-1 ml-1 elevation-0"
                          x-small
                          fab
                          color="blue darken-3"
                        >
                          <v-icon color="white">
                            mdi-account
                          </v-icon>
                        </v-btn>
                        <h5 class="d-block mb-0 ml-1">
                          {{ `${item.user}` }}
                        </h5>
                        <v-icon
                          color="red"
                          class="mx-2 pointer"
                          v-if="user.email == item.user"
                          @click="deleteComment(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                    </div>
                    <p class="d-block hp-p1-body ml-3 mb-1 text-black">
                      {{ item.comment }}
                    </p>
                    <small class="ml-3">
                      {{
                        moment(item.updated_at).format("DD/MM/YYYY HH:mm [hrs]")
                      }}
                    </small>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <p v-else class="text-center mb-8 text-black">
              Sin comentarios
            </p>
            <v-form class="" @submit.prevent="sendNewComment">
              <v-textarea
                :disabled="loading || (currentItem && currentItem.rejected)"
                v-model="$v.form.comment.$model"
                outlined
                cols="8"
                rows="4"
                placeholder="Ingresa aqui el comentario.."
                :error="$v.form.comment.$invalid && submitUpload"
                :error-messages="
                  $v.form.comment.$invalid && submitUpload
                    ? 'Este campo es requerido'
                    : null
                "
              ></v-textarea>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalComments"
          >
            <small>
              Cerrar
            </small>
          </v-btn>
          <v-btn
            @click="sendNewComment"
            :disabled="!form.comment"
            color="primary"
            class="float-right text-white"
          >
            <small>
              Enviar Comentario
            </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import moment from "moment";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalComments: {
      type: Function,
      default: () => {},
    },
    currentItem: {
      default: null,
    },
    commentType: {
      default: null,
    },
  },
  data() {
    return {
      moment,
      loading: false,
      form: {
        comment: "",
      },
      submitUpload: false,
    };
  },
  validations: {
    form: {
      comment: { required },
    },
  },
  methods: {
    ...mapActions({
      createComment: "supplying/createCommentForm",
      sendDeleteCommentForm: "supplying/deleteCommentForm",
    }),
    getTitleFromCurrentItem() {
      return this.currentItem.official_name
        ? this.currentItem.official_name
        : this.currentItem.final_name;
    },
    async sendNewComment() {
      this.submitUpload = true;
      if (!this.$v.form.$invalid) {
        this.loading = true;
        const resp = await this.createComment({
          request_id: this.currentItem.id,
          comment: this.form.comment,
          user: this.user.email,
          comment_type: this.commentType,
        });
        if (resp.status == 200) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: "Comentario agregado correctamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("commentAdded");
          this.closeModalComments(true);
          this.resetForm();
        }
        if (!resp.status || resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    async deleteComment(comment) {
      swal2
        .fire({
          icon: "warning",
          title: `¿Estás seguro de eliminar este comentario?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "red",
          confirmButtonText: `Eliminar`,
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let payload = {
              comment_id: comment.id,
              user: this.user.email,
            };
            const resp = await this.sendDeleteCommentForm(payload);
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Comentario eliminado correctamente`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.$emit("commentDeleted");
              this.closeModalComments(true);
              this.resetForm();
            }
            this.loading = false;
          }
        });
    },
    executeCloseModalComments($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalComments($event);
      }
    },
    resetForm() {
      this.form = {
        comment: "",
      };
      this.submitUpload = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
};
</script>

<style></style>
